import React from "react";
import { AlertTriangle } from "lucide-react";
import { Button } from "./Button";

export function ErrorState({ message, onRetry }: { message?: string; onRetry?: () => void }) {
  return (
    <div className="rounded-lg border border-red-200 bg-red-50 p-6 text-center" data-testid="error-state">
      <AlertTriangle className="mx-auto mb-2 h-6 w-6 text-red-600" />
      <p className="text-sm font-medium text-red-700">{message || "Unable to load this data."}</p>
      {onRetry && (
        <Button variant="outline" size="sm" className="mt-3 text-red-700" onClick={onRetry} data-testid="error-retry-btn">
          Try again
        </Button>
      )}
    </div>
  );
}
